import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    oido: [],
  },

  getters: {
    getOido: (state) => state.oido,
  },

  mutations: {
    SET_OIDO(state, oido) {
      state.oido = oido;
    },
  },

  actions: {
    async fetchOido({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catOido')
        .then((response) => {
          commit('SET_OIDO', response.data.data);
        });
    },
  },
};
